// Status Checker for Full Dataset Loading
// Use this in browser console to check loading status

export const checkLoadingStatus = () => {
  console.log('🔍 CHECKING FULL DATASET LOADING STATUS...');
  console.log('==========================================');
  
  // Check total events
  const totalEvents = MASTER_EVENTS.length;
  console.log(`📊 Total Events: ${totalEvents}`);
  
  if (totalEvents === 1325) {
    console.log('✅ FULL DATASET LOADED! (1,325 events)');
  } else if (totalEvents === 3) {
    console.log('⏳ SAMPLE DATA ONLY (3 events) - Full dataset still loading...');
  } else {
    console.log(`🔄 PARTIAL LOAD (${totalEvents} events) - Loading in progress...`);
  }
  
  // Check category distribution
  const categories = MASTER_EVENTS.reduce((acc, event) => {
    acc[event.categoryPrimary] = (acc[event.categoryPrimary] || 0) + 1;
    return acc;
  }, {});
  
  console.log('\n📈 Category Distribution:');
  Object.entries(categories).forEach(([category, count]) => {
    console.log(`  ${category}: ${count} events`);
  });
  
  // Check format distribution
  const formats = MASTER_EVENTS.reduce((acc, event) => {
    acc[event.format] = (acc[event.format] || 0) + 1;
    return acc;
  }, {});
  
  console.log('\n🌐 Format Distribution:');
  Object.entries(formats).forEach(([format, count]) => {
    console.log(`  ${format}: ${count} events`);
  });
  
  // Check location distribution
  const locations = MASTER_EVENTS.reduce((acc, event) => {
    const location = event.venue || 'Unknown';
    acc[location] = (acc[location] || 0) + 1;
    return acc;
  }, {});
  
  console.log('\n📍 Top Locations:');
  Object.entries(locations)
    .sort(([,a], [,b]) => b - a)
    .slice(0, 10)
    .forEach(([location, count]) => {
      console.log(`  ${location}: ${count} events`);
    });
  
  // Performance check
  console.log('\n⚡ Performance Check:');
  const startTime = performance.now();
  
  // Test filtering performance
  const filteredEvents = MASTER_EVENTS.filter(event => 
    event.categoryPrimary === 'Professional'
  );
  
  const endTime = performance.now();
  const duration = endTime - startTime;
  
  console.log(`  Filtering Performance: ${duration.toFixed(2)}ms`);
  console.log(`  Status: ${duration < 100 ? '✅ FAST' : '⚠️ SLOW'}`);
  
  // Final status
  console.log('\n🎯 FINAL STATUS:');
  if (totalEvents === 1325) {
    console.log('🎉 FULL DATASET SUCCESSFULLY LOADED!');
    console.log('✅ Ready for comprehensive testing!');
    console.log('🚀 All 1,325 Washington D.C. events available!');
  } else {
    console.log('⏳ Still loading full dataset...');
    console.log('🔄 Check back in a few seconds');
  }
  
  return {
    totalEvents,
    isFullDataset: totalEvents === 1325,
    categories,
    formats,
    locations,
    performance: duration
  };
};

// Auto-check every 2 seconds
export const startAutoCheck = () => {
  console.log('🔄 Starting auto-check for full dataset loading...');
  
  const checkInterval = setInterval(() => {
    const status = checkLoadingStatus();
    
    if (status.isFullDataset) {
      console.log('🎉 FULL DATASET LOADED! Auto-check stopped.');
      clearInterval(checkInterval);
    }
  }, 2000);
  
  return checkInterval;
};

// Stop auto-check
export const stopAutoCheck = (intervalId) => {
  clearInterval(intervalId);
  console.log('⏹️ Auto-check stopped.');
};

// Make functions available globally
if (typeof window !== 'undefined') {
  window.checkLoadingStatus = checkLoadingStatus;
  window.startAutoCheck = startAutoCheck;
  window.stopAutoCheck = stopAutoCheck;
  
  console.log('🔧 Status checker functions available:');
  console.log('  - checkLoadingStatus() - Check current status');
  console.log('  - startAutoCheck() - Auto-check every 2 seconds');
  console.log('  - stopAutoCheck(intervalId) - Stop auto-check');
}




